import React, {useState, useEffect} from 'react'
import { reduxForm, Field, getFormValues } from "redux-form";
import { connect } from "react-redux";
import axios from 'axios';
import { store } from "../_helpers";
import InputField from "../_common/InputField";
import SelectSimple from "../_common/SelectSimple";
import Selecciona from "../_common/Selecciona";
import { API_URL } from "../_config";
import SelectSimpleParser from "../_common/SelectSimpleParser";
import SelectDynamic from "../_common/SelectSimple";
import CheckBoxSimple from "../_common/CheckBoxSimple";
import {
  Row,
  Col,
  Card,
  Button,
} from "shards-react";

var provincia = undefined;

const required = value => value ? undefined : 'Ese campo es requerido'

const CrearConcesionaria = props => {
 
    
    const [provincias, setProvincias] = useState([]);
    const [partidos, setPartido] = useState([]);
    const [barrios, setBarrio] = useState([]);

    useEffect(() => {
        axios({
            method: "get",
            url:
              API_URL + "api/region?token=" +
              store.getState().authentication.user.token
          }).then(response => {
            setProvincias(response.data);
          });

  }, []);

    const call_partido = val => {
        axios({
            method: "get",
            url:
              API_URL + "api/region-city/" + val
          }).then(response => {
            setPartido(response.data);
          });
    }
    const call_barrio = val => {
        axios({
            method: "get",
            url:
              API_URL + "api/region-state-city/" + val
          }).then(response => {
            setBarrio(response.data);
          });
    }


  const { handleSubmit, pristine, reset, submitting, error} = props
  return (
    <form onSubmit={handleSubmit}>
      <div>
        <p class="mb-4">(*) = Obligatorio</p>
        <Row>
          
          <Col sm="6">
          <Field
            name="partner"
            component={InputField}
            type="text"
            label="Socio (*)"
            validate={[ required ]}
          />
          <Field
            name="company"
            component={InputField}
            type="text"
            label="Empresa (*)"
            validate={[ required ]}
          />

            <Field
            name="email"
            component={InputField}
            type="email"
            label="Email (*)"
            validate={[ required ]}
          />

          <Field
            name="address"
            component={InputField}
            type="text"
            label="Dirección (*)"
            validate={[ required ]}
          />
          <Field
          name="dni_type"
          label="Tipo de Documento (*)"
          children={[
            ["CI", "CI"],
            ["DU", "DU"],
            ["LC", "LC"],
            ["LE", "LE"]
          ]}
          validate={[ required ]}
          component={SelectSimple}
        ></Field>
          <Field
            name="dni"
            component={InputField}
            type="number"
            label="Número de Documento (*)"
            validate={[ required ]}
          />

          <Field
            name="country"
            children={new Array("Afghanistan","Albania","Algeria","Andorra","Angola","Antarctica","Antigua and Barbuda","Argentina","Armenia","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia","Bosnia and Herzegovina","Botswana","Brazil","Brunei","Bulgaria","Burkina Faso","Burma","Burundi","Cambodia","Cameroon","Canada","Cape Verde","Central African Republic","Chad","Chile","China","Colombia","Comoros","Congo, Democratic Republic","Congo, Republic of the","Costa Rica","Cote d'Ivoire","Croatia","Cuba","Cyprus","Czech Republic","Denmark","Djibouti","Dominica","Dominican Republic","East Timor","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Ethiopia","Fiji","Finland","France","Gabon","Gambia","Georgia","Germany","Ghana","Greece","Greenland","Grenada","Guatemala","Guinea","Guinea-Bissau","Guyana","Haiti","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Israel","Italy","Jamaica","Japan","Jordan","Kazakhstan","Kenya","Kiribati","Korea, North","Korea, South","Kuwait","Kyrgyzstan","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macedonia","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Mauritania","Mauritius","Mexico","Micronesia","Moldova","Mongolia","Morocco","Monaco","Mozambique","Namibia","Nauru","Nepal","Netherlands","New Zealand","Nicaragua","Niger","Nigeria","Norway","Oman","Pakistan","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Poland","Portugal","Qatar","Romania","Russia","Rwanda","Samoa","San Marino"," Sao Tome","Saudi Arabia","Senegal","Serbia and Montenegro","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","Spain","Sri Lanka","Sudan","Suriname","Swaziland","Sweden","Switzerland","Syria","Taiwan","Tajikistan","Tanzania","Thailand","Togo","Tonga","Trinidad and Tobago","Tunisia","Turkey","Turkmenistan","Uganda","Ukraine","United Arab Emirates","United Kingdom","United States","Uruguay","Uzbekistan","Vanuatu","Venezuela","Vietnam","Yemen","Zambia","Zimbabwe")}
            component={Selecciona}
            label="País (*)"
            validate={[ required ]}
          />

          <Field
            name="region_id"
            children={provincias}
            component={SelectSimpleParser}
            label="Provincia (*)"
            validate={[ required ]}
            onChange={(e) => {
                const val = e.target.value
                if(val != ''){
                   call_partido(val);
                }
            }}
          />

            <Field
            name="region_city_id"
            children={partidos}
            component={SelectSimpleParser}
            validate={[ required ]}
            label="Partido (*)"
            onChange={(e) => {
                const val = e.target.value
                if(val != ''){
                   call_barrio(val);
                }
            }}
          />

         <Field
            name="region_barrio_id"
            children={barrios}
            validate={[ required ]}
            component={SelectSimpleParser}
            label="Barrio (*)"
          />

          
         <Field
            name={'validated'}
            label={'Es Socio de la CCA'}
            component={CheckBoxSimple}
            type="checkbox"
         
            id="validatedCheck"
        ></Field>
        <p style={{marginTop:'-11px', marginLeft: '0px', fontSize: '12px'}}>(Podrá acceder a todas las características del sistema) </p>
          </Col>
          <Col sm="6">
          <Field
            name="cuit"
            component={InputField}
            type="number"
            label="CUIT (Sin guíones) (*)"
            validate={[ required ]}
          />
           <Field
            name="last_name"
            component={InputField}
            validate={[ required ]}
            type="text"
            label="Apellido (*)"
          />
            <Field
            name="name"
            component={InputField}
            validate={[ required ]}
            type="text"
            label="Nombre (*)"
          />

         <Field
            name="phone"
            component={InputField}
            validate={[ required ]}
            type="number"
            label="Teléfono (*)"
          />

          <Field
            name="phone2"
            component={InputField}
            validate={[ required ]}
            type="number"
            label="Segundo Telefono (*)"
          />


          <Field
            name="cellphone"
            component={InputField}
            validate={[ required ]}
            type="number"
            label="Celular (*)"
          />

        <Field
            name={'whatsapp'}
            component="input"
            
            type="checkbox"
        ></Field> WhatsApp 
          
          <br/><br/>
          <Field
            name="contact"
            component={InputField}
            validate={[ required ]}
            type="text"
            label="Contacto (*)"
          />

          <Field
            name="work_hours"
            component={InputField}
            validate={[ required ]}
            type="text"
            label="Horarios (*)"
            valor="hola"
          />

          <Field
            name="zip_code"
            component={InputField}
            validate={[ required ]}
            type="text"
            label="Código Postal (*)"
          />
          
          </Col>
        </Row>
        </div>
  
        <br/>
        {error && <strong>{error}</strong>}
        <Button type="submit" disabled={submitting}>
            Crear
        </Button>
    </form>
  )
}

function mapState(state, props) {
   
  const { users, authentication, vehicles, adminuser } = state;

  const { user } = authentication;

  if(props.activedX) {
    return { user, users, adminuser, initialValues: props.activedX};
  }else{
    return { user, users, adminuser};
  }
}
const actionCreators = {

};

const po = reduxForm({
form: 'CrearConcesionaria', 
enableReinitialize: true
})(CrearConcesionaria);

const pox = connect(
  mapState,
  actionCreators
)(po);

export { pox as CrearConcesionaria };

